import React from 'react';
import { Modal, Typography, Button } from '@crisellevaldez/speculo-ui';
import { ExternalLink, CreditCard, Share2, Gift } from 'lucide-react';

interface ReferralModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const ReferralModal: React.FC<ReferralModalProps> = ({ isOpen, onClose }) => {
  const REFERRAL_URL = 'https://speculo.firstpromoter.com/';

  const steps = [
    {
      icon: ExternalLink,
      title: 'Set Up Your Account',
      description: 'Click the button below to create your affiliate account in just a few minutes.',
      action: (
        <a href={REFERRAL_URL} target="_blank" rel="noopener noreferrer">
          <Button variant="primary" size="sm" className="gap-2 mt-2">
            <ExternalLink className="w-4 h-6" />
            Create Affiliate Account
          </Button>
        </a>
      ),
    },
    {
      icon: CreditCard,
      title: 'Connect Your Payout Method',
      description:
        'Connect your payout method to ensure all auto commissions get paid out directly to you.',
    },
    {
      icon: Share2,
      title: 'Share Your Referral Link',
      description:
        'Put your referral link EVERYWHERE so we can keep track automatically on anyone that finds us through you.',
    },
  ];

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg">
      <Modal.Header className="gap-4">
        <Typography variant="h3">
          Looking to make some commish off getting your friends to hire the smartest AI in real
          estate just like you?
        </Typography>
      </Modal.Header>
      <Modal.Body>
        <div className="space-y-6">
          {/* Steps Header */}
          <div>
            <h3 className="text-base text-gray-900 dark:text-gray-100">
              Follow these quick and easy steps to get set up!!
            </h3>
          </div>

          {/* Steps */}
          <div className="space-y-6">
            {steps.map((step, index) => (
              <div
                key={index}
                className="group flex items-start gap-5 p-5 bg-white dark:bg-white/5 rounded-lg border border-gray-300 dark:border-white/15 shadow-md hover:shadow-lg hover:border-primary/50 transition-all duration-300"
              >
                <div className="flex-shrink-0">
                  <div className="w-10 h-10 bg-primary rounded-full flex items-center justify-center text-black font-bold text-lg shadow-md group-hover:scale-110 transition-transform duration-300">
                    {index + 1}
                  </div>
                </div>
                <div className="flex-1 pt-1">
                  <div className="flex items-center gap-2 mb-2">
                    <step.icon className="w-5 h-5 text-primary" />
                    <h4 className="font-bold text-gray-800 dark:text-gray-200 text-base">{step.title}</h4>
                  </div>
                  <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed">{step.description}</p>
                  {step.action && <div>{step.action}</div>}
                </div>
              </div>
            ))}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>{null}</Modal.Footer>
    </Modal>
  );
};
